import { base_colorContentBorder, grey150 } from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.interactive {
    // Change width here. Use "interactive" if using a different variant
    // All changes here will affect the modal as a whole

    // To ensure all content is visible
    overflow: scroll;

    // width of a popup modal overriding the interactive width
    width: 678px;
  }

  &.ManagerReviewRejectionModal .BaseModal-Body {
    // Override any Modal styling here! This will be your main target CSS selector
    padding: ${spacing(10)};

    .transactionDetails {
      display: flex;
      flex-direction: column;
      padding: ${spacing(5)};
      gap: ${spacing(3)};
      align-self: stretch;
      border-radius: ${cornerRadius};
      border: 1px solid ${base_colorContentBorder};
      background: ${grey150};

      .transactionDetails-detailItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
      }
    }
  }
`
